// extracted by mini-css-extract-plugin
export default {"dropTargetWrapper":"DropTargetWrapper_dropTargetWrapper__mfaca"};